import { render, staticRenderFns } from "./ToggleFilter.vue?vue&type=template&id=3487b5fe&"
import script from "./ToggleFilter.vue?vue&type=script&lang=js&"
export * from "./ToggleFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports